var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 0.333313C3.82004 0.333313 0.833374 3.31998 0.833374 6.99998C0.833374 10.68 3.82004 13.6666 7.50004 13.6666C11.18 13.6666 14.1667 10.68 14.1667 6.99998C14.1667 3.31998 11.18 0.333313 7.50004 0.333313ZM9.85337 7.01998C9.75337 7.11998 9.62671 7.16665 9.50004 7.16665C9.37337 7.16665 9.24671 7.11998 9.14671 7.01998L8.00004 5.87331V9.33331C8.00004 9.60665 7.77337 9.83331 7.50004 9.83331C7.22671 9.83331 7.00004 9.60665 7.00004 9.33331V5.87331L5.85337 7.01998C5.66004 7.21331 5.34004 7.21331 5.14671 7.01998C4.95337 6.82665 4.95337 6.50665 5.14671 6.31331L7.14671 4.31331C7.34004 4.11998 7.66004 4.11998 7.85337 4.31331L9.85337 6.31331C10.0467 6.50665 10.0467 6.82665 9.85337 7.01998Z",
    fill: "#2CC7A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessUp);
export default __webpack_public_path__ + "static/media/success-up.1784642c.svg";
export { ForwardRef as ReactComponent };